/**
 * valumize API for managing assets
 * An asset mostly represents a company and contains basic information such as a name, description and currency as well as historical financial data such as revenues, ebitda or net debt. Each asset can have multiple asset valuations. An asset valuation may include calculations, forecasts etc. An asset valuation always refers to a specific date on which the report, which serves as the basis for the valuation, was created. Moreover, it always belongs to an asset and cannot exist independently of it.
 *
 * The version of the OpenAPI document: 0.0.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AssetValuationScenario } from './asset-valuation-scenario';
import { AssetValuation } from './asset-valuation';


export interface DiscountMultipleValuation { 
    assetValuation: AssetValuation;
    scenarios: Array<AssetValuationScenario>;
    valuationInput: DiscountMultipleValuation.ValuationInputEnum;
    gpQuality?: DiscountMultipleValuation.GpQualityEnum;
    /**
     * Confidence of the valuation algorithm\'s interpolated values relative to its calibrated anchor grid; only set on responses calculated with the algorithm
     */
    confidenceZone?: DiscountMultipleValuation.ConfidenceZoneEnum;
}
export namespace DiscountMultipleValuation {
    export type ValuationInputEnum = 'CF' | 'MULTIPLE';
    export const ValuationInputEnum = {
        Cf: 'CF' as ValuationInputEnum,
        Multiple: 'MULTIPLE' as ValuationInputEnum
    };
    export type GpQualityEnum = 'LOW' | 'MEDIUM' | 'HIGH';
    export const GpQualityEnum = {
        Low: 'LOW' as GpQualityEnum,
        Medium: 'MEDIUM' as GpQualityEnum,
        High: 'HIGH' as GpQualityEnum
    };
    export type ConfidenceZoneEnum = 'WITHIN_RANGE' | 'NEAR_EDGE' | 'OUTSIDE_RANGE';
    export const ConfidenceZoneEnum = {
        WithinRange: 'WITHIN_RANGE' as ConfidenceZoneEnum,
        NearEdge: 'NEAR_EDGE' as ConfidenceZoneEnum,
        OutsideRange: 'OUTSIDE_RANGE' as ConfidenceZoneEnum
    };
}


